import React from "react";

const SectionHeading = ({ className, children }) => {
    return (
        <div
            className={`text-prime text-center font-semibold text-2xl p-2 ${className}`}
        >
            {children}
        </div>
    );
};

export default SectionHeading;
